import React from "react";
import { View, StyleSheet } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtSectionButton from "../general/NtSectionButton";
import { useMobile } from "../../../hooks/useMobile";

function NtE911Section(props) {
  const isMobile = useMobile();
  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/e911-cover.jpeg")}
    >
      <View style={{ flex: 1, flexDirection: "row" }}>
        {!isMobile && <View style={{ flex: 1 }} />}
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left", fontSize: 28 }}>
            ENHANCED 911 ACCESS
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 10 }}>
            Connect your company to emergency services with fast, reliable,
            accurate E911 services
          </NtSectionDescription>
          <NtSectionDescription style={{ fontWeight: "800", marginTop: 4 }}>
            Deploy Quickly, Reliably and Affordably.
          </NtSectionDescription>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    height: 600,
  },
});

export default NtE911Section;
